(() => {
  const SELECTOR = '[data-cart-upsell-add]';

  function sectionsToRequest(cart) {
    const ids = [];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      cart.getSectionsToRender().forEach((section) => {
        if (section.id && !ids.includes(section.id)) ids.push(section.id);
      });
    } else {
      ids.push('cart-drawer', 'cart-icon-bubble');
    }
    if (document.getElementById('main-cart-footer') && !ids.includes('main-cart-footer')) {
      ids.push('main-cart-footer');
    }
    if (document.getElementById('main-cart-items') && !ids.includes('main-cart-items')) {
      ids.push('main-cart-items');
    }
    return ids;
  }

  function renderExtraSections(data) {
    if (!data || !data.sections) return;

    const footer = document.getElementById('main-cart-footer');
    if (footer && data.sections['main-cart-footer']) {
      const doc = new DOMParser().parseFromString(data.sections['main-cart-footer'], 'text/html');
      const next = doc.getElementById('main-cart-footer') || doc.querySelector('.shopify-section');
      if (next) footer.innerHTML = next.innerHTML;
    }

    const itemsWrap = document.getElementById('main-cart-items');
    if (itemsWrap && data.sections['main-cart-items']) {
      const doc = new DOMParser().parseFromString(data.sections['main-cart-items'], 'text/html');
      const sectionRoot = doc.querySelector('.shopify-section') || doc.body;
      const source = sectionRoot.querySelector('.js-contents');
      const target = itemsWrap.querySelector('.js-contents');
      if (source && target) target.innerHTML = source.innerHTML;
    }
  }

  async function addVariantToCart(variantId, triggerButton) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (triggerButton && triggerButton.dataset.firstCaseTry === '1') {
      formData.append('properties[_fll_first_case_try]', '1');
    }

    const sectionIds = sectionsToRequest(cart);
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });
    const data = await response.json();

    if (data.status) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'cart-upsell',
          productVariantId: variantId,
          errors: data.errors || data.description,
          message: data.message,
        });
      }
      throw new Error(data.description || data.message || 'Cart add failed');
    }

    // Drop stale offers on the cart page behind the drawer immediately
    document.querySelectorAll('[data-fll-cart-upsell]').forEach((el) => el.remove());

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-upsell',
        productVariantId: variantId,
        cartData: data,
      });
    }

    if (cart && typeof cart.renderContents === 'function') {
      if (triggerButton && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(triggerButton);
      }
      cart.renderContents(data);
    }

    renderExtraSections(data);
    return data;
  }

  function onClick(event) {
    const button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('aria-disabled') || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    addVariantToCart(variantId, button)
      .catch((err) => {
        console.error('cart-upsell', err);
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('click', onClick);
})();
